module.exports = (__webpack_require__(7))(458);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/angular2-infinite-scroll/angular2-infinite-scroll.js from dll-reference vendor
// module id = 1205
// module chunks = 0